module.exports = __webpack_public_path__ + "static/media/Marduk.6c7c939a.jpg";